import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Free Consultation",
    body: "We hop on a 30-min call, understand your business, audience and goals. Zero pressure.",
  },
  {
    n: "02",
    title: "Planning & Design",
    body: "I send a clear scope, sitemap and design direction. You approve before a single line of code.",
  },
  {
    n: "03",
    title: "Development",
    body: "Custom-coded, mobile-first, SEO-ready build with live preview links you can review daily.",
  },
  {
    n: "04",
    title: "Launch & Support",
    body: "We launch, set up analytics & SEO, then I stay on to support, maintain and grow it.",
  },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 border-t border-white/5 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            How We'll Work
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-white">
            A simple <span className="gold-text italic">4-step</span> process.
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-6 md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#D4AF37]/40 to-transparent md:-translate-x-1/2" />
          <div className="space-y-8 md:space-y-16">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                data-testid={`process-step-${i}`}
                className={`relative flex flex-col md:flex-row md:items-center gap-6 ${
                  i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                }`}
              >
                <div className="md:w-1/2 md:px-12">
                  <div className="bg-[#0A0A0A] border border-[#222222] rounded-2xl p-7 hover:border-[#D4AF37]/40 transition-colors">
                    <div className="font-mono text-xs text-[#D4AF37] tracking-widest mb-3">
                      STEP {s.n}
                    </div>
                    <h3 className="font-display text-2xl text-white mb-3">{s.title}</h3>
                    <p className="text-[#B0B0B0] leading-relaxed">{s.body}</p>
                  </div>
                </div>

                <div className="absolute left-6 md:left-1/2 -translate-x-1/2 top-7 md:top-1/2 md:-translate-y-1/2">
                  <div className="w-3 h-3 rounded-full bg-[#D4AF37] gold-glow" />
                </div>

                <div className="hidden md:block md:w-1/2" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
